import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoadingInterceptor } from './loading.interceptor';
import { AboutPageOneComponent } from './components/about-page-one/about-page-one.component';
import { ActivityComponent } from './components/activity/activity.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { BlogDetailsPageComponent } from './components/blog-details-page/blog-details-page.component';
import { PublicNewsComponent } from './components/public-news/public-news.component';
import { NewsComponent } from './components/news/news.component';
import { HometwoAboutComponent } from './components/hometwo-about/hometwo-about.component';
import { FooterComponent } from './components/footer/footer.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { HometwoCoursesComponent } from './components/hometwo-courses/hometwo-courses.component';
import { FaqPageComponent } from './components/faq-page/faq-page.component';
import { FeedbackStyleTwoComponent } from './components/feedback-style-two/feedback-style-two.component';
import { HeaderStyleTwoComponent } from './components/header-style-two/header-style-two.component';
import { InstructorsStyleTwoComponent } from './components/instructors-style-two/instructors-style-two.component';
import { SharedModule } from './shared/shared.module';
import { NgIf, CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NgbDropdownModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { CountUpModule } from 'ngx-countup';
import { LightboxModule } from 'ngx-lightbox';
import { SwiperModule } from 'swiper/angular';
import { AppComponent } from './app.component';
import { HomePageTwoComponent } from './components/home-page-two/home-page-two.component';
import { LanguageSelectorComponent } from './components/header-style-two/language-selector/language-selector.component';
import { FunfactsComponent } from './components/funfacts/funfacts.component';
import { ContactPageComponent } from './components/contact-page/contact-page.component';
import { PartnerStyleOneComponent } from './components/partner-style-one/partner-style-one.component';
import { ThemeCustomizerComponent } from './components/theme-customizer/theme-customizer.component';
import { BecomeInstructorPartnerComponent } from './components/become-instructor-partner/become-instructor-partner.component';
import { HometwoMainBannerComponent } from './components/home-page-two/hometwo-main-banner/hometwo-main-banner.component';
import { ContentLoaderComponent } from './components/content-loader/content-loader.component';
import { NewsDetailsComponent } from './components/news-details/news-details.component';
import { ActivityDetailsComponent } from './components/activity-details/activity-details.component';
import { PublicNewsDetailsComponent } from './components/public-news-details/public-news-details.component';

export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}
@NgModule({
    declarations: [PublicNewsDetailsComponent,ActivityDetailsComponent,NewsDetailsComponent,ContentLoaderComponent,BecomeInstructorPartnerComponent,ThemeCustomizerComponent,PartnerStyleOneComponent,ContactPageComponent,FunfactsComponent,AppComponent,HomePageTwoComponent,LanguageSelectorComponent,
        FeedbackStyleTwoComponent, HeaderStyleTwoComponent, FaqPageComponent, HometwoCoursesComponent, ErrorPageComponent, FooterComponent, HometwoMainBannerComponent, AboutPageOneComponent, HometwoAboutComponent, PublicNewsComponent, InstructorsStyleTwoComponent, ActivityComponent, PrivacyPolicyComponent, BlogDetailsPageComponent, NewsComponent,],
    imports: [
        TranslateModule.forRoot(),
        NgbDropdownModule,
        NgbDropdownModule,
        NgbProgressbarModule,
        HttpClientModule,
        ReactiveFormsModule,
        RouterLink,
        NgIf, SharedModule, CommonModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SwiperModule,
        CountUpModule,
        NgxScrollTopModule,
        LightboxModule,
        FormsModule,
        ToastrModule.forRoot({
            timeOut: 1500,
            positionClass: 'toast-bottom-right'
        }),
        AppRoutingModule,

    ],
    providers: [TranslateService, { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true }
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }